import { Observable, EMPTY, of } from 'rxjs';

import { catchError, finalize, switchMap } from 'rxjs/operators';
import { Component, OnInit, ElementRef, OnDestroy, Optional } from '@angular/core';
import {
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver
} from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';

// componentes
import { messageTaskComponent } from '../messageTask/messageTask.component';
import { basicDocumentComponent } from '../../documents/basicDocument/basicDocument.component';
import { documentViewerComponent } from '../../documents/documentViewer/documentViewer.component';
import { emptyComponent } from '../../components/empty.component';

import { PlycaDataService } from '../../../services/plyca.service';
import { getSimpleIdentifierFromString, TaskDTO } from '../../api/plyca-dtos';
import { TaskService } from '../task.service';
import { generateRandomIdentifier, UIService } from '../../ui.service';
import { tenderEventComponent } from '../../dossiers/tenderEvent/tenderEvent.component';
import { publicationInfoComponent } from '../../dossiers/publicationInfo/publicationInfo.component';
import { eTenderingDefinitionComponent } from '../../dossiers/eTenderingDefinition/eTenderingDefinition.component';
import { procurementProjectComponent } from '../../dossiers/genericDossier/procurementProject.component';
import { procurementProjectAYMADComponent } from '../../aymad/procurementProject/procurementProjectAYMAD.component';
import { tenderEvaluationComponent } from '../../dossiers/tenderView/tenderEvaluation.component';
import { TenderClassificationComponent } from '../tenderClassification/component/tenderClassification.component';
import { awardsListComponent } from '../../dossiers/awards/awardsList.component';
import {
  HelpService,
  HelpType
} from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { tenderListComponent } from '../../dossiers/tenderView/tenderList.component';
import { CommunicationEditionComponent } from '../../dossiers/communications/communication.edition.component';
import { ContractComponent } from '../../dossiers/contracts/contract.component';
import { ContractAYMADComponent } from '../../aymad/contracts/contractAYMAD.component';
import { InvoicesComponent } from '../../dossiers/invoices/invoices.component';
import { accountingViewComponent } from '../../dossiers/accounting/accounting.component';
import { ContractModificationComponent } from '../../dossiers/contractModifications/contractModification.component';
import { AccountingDocumentComponent } from '../../dossiers/accounting/accountingDocument.component';
import { ReceiptComponent } from '../receipt/component/receipt.component';
import { EndorsementComponent } from '../endorsement/component/endorsement.component';
import { SettlementComponent } from '../settlement/component/settlement.component';
import { CertificationComponent } from '../certification/component/certification.component';
import { RegisterContractModificationComponent } from '../../dossiers/registerContractModifications/registerContractModification.component';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { GuaranteeRefundComponent } from '../guaranteeRefund/component/guaranteeRefund.component';
import { AssignManagerComponent } from '../assignManager/component/assignManager.component';
import { TaskAssignmentComponent } from '../taskAssignment/component/taskAssignment.component';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { FinanceProjectComponent } from '../../bsm/financeproject.component';
import { BudgetaryProjectsComponent } from '../../sarga/budgetaryProjects/budgetaryProject.component';
import { OrderProjectsComponent } from '../../sarga/orderproject/orderprojects.component';
import { IncomeComponent } from '../../bsm/income.component';
import { AppConfiguration } from '../../conf/app.configuration';
import { CodeInclusionComponent } from '../codeinclusion/codeInclusion.component';
import { DebtInquiriesComponent } from '../../integration/debtinquiries.component';
import { ProcedureCircuitComponent } from '../../dossiers/procedures/procedureCircuit.component';
import { ChangePhaseTaskComponent } from '../changePhaseTask/changePhaseTask.component';
import { ProcurementProjectLotStateInfoComponent } from '../procurementProjectLotStateInfo/component/procurementProjectLotStateInfo.component';
import { SpendingProjectsComponent } from '../../dipbad/spendingProject/spendingProjects.component';
import { AYMADContractModificationComponent } from '../../aymad/contractModifications/AYMADContractModification.component';
import { CertificationPaymentComponent } from '../../dipbad/certificationPayment/certificationPayment.component';




@Component({
  selector: 'baseTask',
  templateUrl: 'baseTask.template.html',
  providers: [DialogService]
})
export class baseTaskComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild('parent', { read: ViewContainerRef })
  parent: ViewContainerRef;

  private idTarea = '-';
  public description = '';
  public dossier: any;
  public project: any;
  division: any;
  // protected loadingInfo: LoadingInfo;
  taskSelected: TaskDTO;

  // referencia a la url desde que se ha hecho la apertura para volver al mismo componente
  from: string;
  fromParams: string;

  instance: any;
  public isLoading = true;
  public withActions = false;
  //private isModalWindow: boolean;
  public windowHash: string;

  cliente: any;

  constructor(
    private route: ActivatedRoute,
    protected appConfig: AppConfiguration,
    public helpService: HelpService,
    public componentFactoryResolver: ComponentFactoryResolver,
    public uiService: UIService,
    public plycaService: PlycaDataService,
    public taskService: TaskService,
    private headerActionService: HeaderActionsService,
    private waitService: WaitLoadingService,
    private dialogService: DialogService,
    private plycaErrorHandler: PlycaErrorHandler,
    @Optional() protected dialogRef: DynamicDialogRef,
    @Optional() protected dialogConfig: DynamicDialogConfig,
    private elem: ElementRef
  ) {
    super();
    // La lógica del helpservice ya incluye este tag cuaando hay tarea
    // this.helpService.showContextHelp(HelpType.HELP_TASK);
  }

  ngOnInit(): void {
    this.waitService.startWaiting();
    let isModalWindow = this.dialogConfig && this.dialogConfig.data !== undefined;
    let taskIdObservable: Observable<any>;
    if (isModalWindow) {
      taskIdObservable = of(this.dialogConfig.data.taskId);
      this.windowHash = generateRandomIdentifier();
    } else {
      taskIdObservable = this.route.params.pipe(
        switchMap((params) => of(params['id']))
      );
    }
    this.subscribe(taskIdObservable, (idTarea: string) => {
      // limpiamos el contenido viewChild
      if (this.parent) {
        this.parent.clear();
      }

      this.idTarea = idTarea;
      let lockObservable = this.taskService.lockTask(this.idTarea).pipe(
        catchError(err => {

          // ERROR AL ABRIR UNA TAREA
          this.subscribe(this.plycaErrorHandler.showServerError(err).onClose, () => {
            if (this.windowHash) {
              this.dialogRef.close();
            } else {
              this.waitService.startWaiting();
              this.subscribe(this.taskService.consultaTareasObservable()
                .pipe(finalize(() => {

                  this.waitService.cancelWaiting();
                  this.uiService.routeBack();
                })));
            }
          });
          return EMPTY;
        })
      );

      // LA TAREA SE ABRE OK
      this.subscribe(lockObservable, (task: TaskDTO) => {
        console.log('--> getTask');
        this.description = task.description;
        let component = this.getComponentByType(task);

        // Si el componente requiere la tarea con acciones al abrir la consultamos de nuevo
        if (this.withActions) {

          this.subscribe(
            this.taskService.getTaskWithActions(task.identifier)
            , (t) => {
              this.createTaskComponent(t, component);
            });
        } else {
          this.createTaskComponent(task, component);
        }

      });
    });
  }

  createTaskComponent(task: TaskDTO, component: any) {
    const childComponent = this.componentFactoryResolver.resolveComponentFactory(
      component
    );

    // at this point we want the "child" component to be rendered into the app.component:
    this.instance = this.parent.createComponent(childComponent).instance;
    this.taskSelected = task;
    this.instance['task'] = task;
    this.instance['from'] = this.from;
    this.instance['fromParams'] = this.fromParams;
    this.instance['modalWindowHash'] = this.windowHash;
    console.log('base task dialogref', this.dialogRef);
    console.log('task ' + task);
    this.project = task.division.project;
    this.division = getSimpleIdentifierFromString(task.division.identifier);

    if (!this.windowHash) {
      let div: any = 0;
      if (task.division.identifier && !task.division.identifier.startsWith("0<>"))
        div = task.division
      // TODO revisar si alguna tarea de abre en modal
      this.headerActionService.setProject(this.elem, this.project, true, false, false, div);
      this.headerActionService.setTaskDescription(
        this.elem,
        this.description,
        'fa-tasks',
        true
      );
      this.headerActionService.setShowDocumentsVisible(true);
      this.headerActionService.setShowCalendarVisible(true);
    }
    //Para evitar el problema de detección del cambio en *ngIf=isLoadin()
    // this.changeDetectorRef.detectChanges();

  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.dialogConfig = null;
    this.dialogRef = null;
    this.dialogService = null;
  }

  // dossierLoaded(): boolean {
  //   return this.project != null;
  // }

  /*
   * Decide el componente a utilizar en funcion del tipo de tarea
   */
  getComponentByType(task: TaskDTO): any {
    console.log('WORKTYPE: ' + task.workType);
    switch (task.workType) {
      case 'MESSAGE':
        return messageTaskComponent; // Componente sin ayuda de pantalla
      case 'ASSIGNMANAGER':
        return AssignManagerComponent; // Componente sin ayuda de pantalla
      case 'TASKASSIGNMENT':
        return TaskAssignmentComponent; // Componente sin ayuda de pantalla
      case 'PROCUREMENT_COMMITEE':
        return tenderEventComponent; // Componente sin ayuda de pantalla
      case 'PUBLICACION_BOC':
        return publicationInfoComponent; // Componente sin ayuda de pantalla
      case 'TENDER':
        return tenderListComponent; // Componente sin ayuda de pantalla
      case 'DOSSIER_OF':
        return tenderEvaluationComponent; // *AYUDA en pantalla
      case 'FICHA_ADJ':
        return awardsListComponent; // Componente sin ayuda de pantalla
      case 'RECO': {
        this.cliente = this.appConfig.getValue('cliente');
        if (this.cliente && this.cliente === 'AYMAD') {
          return ContractAYMADComponent;
        } else {
          return ContractComponent;
        }
      }
      case 'REPLYCA': {
        this.cliente = this.appConfig.getValue('cliente');
        if (this.cliente && this.cliente === 'AYMAD') {
          return ContractAYMADComponent;
        } else {
          return ContractComponent;
        }
      }
      case 'REPLYCA_CBAM': {
        this.cliente = this.appConfig.getValue('cliente');
        if (this.cliente && this.cliente === 'AYMAD') {
          return ContractAYMADComponent;
        } else {
          return ContractComponent;
        }
      }
      case 'DOSSIER_EXP': {
        this.cliente = this.appConfig.getValue('cliente');
        if (this.cliente && this.cliente === 'AYMAD') {
          return procurementProjectAYMADComponent;
        } else {
          return procurementProjectComponent;
        }
      }
      case 'DOCUMENTSIGNATURE': {
        this.withActions = true;
        return documentViewerComponent;
      }
      case 'DOCUMENT': {
        // if (task.type === 'Sign') {
        //   this.withActions = true;
        //   return documentViewerComponent;
        // } else {
        return basicDocumentComponent;
        // }
      }
      case 'DOSSIER_MC':
      case 'TENDER_DEFINITION': {
        return eTenderingDefinitionComponent;
      }
      case 'TENDERCLASSIFICATION': {
        return TenderClassificationComponent;
      }
      case 'NOTIFICATION': {
        return CommunicationEditionComponent;
      }
      case 'DOSSIER_F': {
        return InvoicesComponent;
      }
      case 'GEST_GASTO': {
        return accountingViewComponent;
      }
      case 'DOC_CONTABLE': {
        return AccountingDocumentComponent;
      }
      case 'FICHA_INC': {
        this.cliente = this.appConfig.getValue('cliente');
        if (this.cliente && this.cliente === 'AYMAD') {
          return AYMADContractModificationComponent;
        } else {
          return ContractModificationComponent;
        }
      }
      case 'PROCUREMENTPROJECT_LOT_STATE_INFO': {
        return ProcurementProjectLotStateInfoComponent;
      }
      case 'ENDORSEMENT': {
        return EndorsementComponent;
      }
      case 'RECEIPT': {
        return ReceiptComponent;
      }
      case 'SETTLEMENT': {
        return SettlementComponent;
      }
      case 'CERTIFICATION': {
        return CertificationComponent;
      }
      case 'GUARANTEE_REFUND': {
        return GuaranteeRefundComponent;
      }
      case 'REGISTER_FICHA_INC': {
        return RegisterContractModificationComponent;
      }

      case 'BUDGETARY_PROJECT': {
        return BudgetaryProjectsComponent;
      }
      case 'SPENDING_PROJECT': {
        return SpendingProjectsComponent;
      }
      case 'ORDER_PROJECT': {
        return OrderProjectsComponent;
      }
      case 'FINANCE_PROJECT': {
        return FinanceProjectComponent;
      }
      case 'INCOME': {
        return IncomeComponent;
      }
      case 'CODE_INCLUSION': {
        return CodeInclusionComponent;
      }
      case 'CONSULTA_AEAT': {
        return DebtInquiriesComponent;
      }
      case 'CONSULTA_TGSS': {
        return DebtInquiriesComponent;
      }
      case 'CONSULTA_CCAA': {
        return DebtInquiriesComponent;
      }
      case 'PROCEDURE_CIRCUIT': {
        return ProcedureCircuitComponent;
      }
      case 'PHASE_CHANGE': {
        return ChangePhaseTaskComponent;
      }
      case 'SPENDINGPROJECT': {
        return SpendingProjectsComponent;
      }
      case 'CERTIFICATIONPAYMENT': {
        return CertificationPaymentComponent;
      }
      default:
        return emptyComponent;
    }
  }

  // private setLoadingInfo(loadingInfo: LoadingInfo): void {
  //   this.loadingInfo = loadingInfo;
  //   if (loadingInfo) {
  //     this.waitService.setLoadingInfo(loadingInfo);
  //   }
  //   // if (loadingInfo && loadingInfo.loading !== undefined) { //  && loadingInfo.loading !== this.isLoading
  //   //   this.isLoading = loadingInfo.loading;
  //   //   this.changeDetectorRef.detectChanges();
  //   // }
  //   // return (
  //   //   !this.dossierLoaded() || (this.loadingInfo && this.loadingInfo.loading)
  //   // );
  // }

  canDeactivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    //    canDeactivate(): boolean {
    if (this.instance && this.instance.canDeactivate) {
      return this.instance.canDeactivate(route, state);
    } else {
      return true;
    }
  }

}
